import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import {
  Button,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { FullSizeColumn } from '../../../Components/FlexBox';
import DateRangePicker from '../../Dashboard/DateRangePicker';
import { CloseRounded } from '@mui/icons-material';

const CampaignsFilters = function CampaignsFilters({
  defaultValue = {},
  onConfirm = () => {},
  onClose = () => {},
}) {
  const intl = useIntl();
  const [status, setStatus] = useState(
    defaultValue?.isActive === null ? 'ALL' : defaultValue?.isActive
  );
  const [rangeDialog, setRangeDialog] = useState(false);
  const [periodRange, setPeriodRange] = useState([
    defaultValue?.startDate ?? null,
    defaultValue?.endDate ?? null,
  ]);

  const handleChangeStatus = (event) => {
    setStatus(event.target.value);
  };

  const handleConfirm = () => {
    onConfirm({
      isActive: status === 'ALL' ? null : status,
      startDate: periodRange[0] ?? null,
      endDate: periodRange[1] ?? null,
    });
    onClose();
  };

  return (
    <FullSizeColumn minHeight="160px" minWidth="300px" gap="16px">
      <FormControl fullWidth>
        <InputLabel id="status-select-inputlabel">
          {intl.messages.STATUS}
        </InputLabel>
        <Select
          id="status-select"
          label={intl.messages.STATUS}
          value={status}
          onChange={handleChangeStatus}
        >
          <MenuItem value="ALL">{intl.messages.ALL}</MenuItem>
          <MenuItem value={true}>{intl.messages.ACTIVE}</MenuItem>
          <MenuItem value={false}>{intl.messages.INACTIVE}</MenuItem>
        </Select>
      </FormControl>
      <TextField
        id="date-range-txtField"
        label={intl.messages.PERIOD}
        onClick={() => setRangeDialog(true)}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  disabled={!periodRange[0] && !periodRange[1]}
                  onClick={(e) => {
                    e.stopPropagation();
                    setPeriodRange([null, null]);
                  }}
                >
                  <CloseRounded />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
        value={
          periodRange[0] && periodRange[1]
            ? `${new Date(periodRange[0]).toLocaleDateString()} - ${new Date(
                periodRange[1]
              ).toLocaleDateString()}`
            : ''
        }
      />
      <DateRangePicker
        open={rangeDialog}
        close={() => setRangeDialog(false)}
        periodRange={periodRange}
        setPeriodRange={(newRange) => setPeriodRange(newRange)}
        disableMaxDate
      />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          marginTop: "auto"
        }}>
        <Button id="confirm-filters-btn" size="large" onClick={handleConfirm}>
          {intl.messages.CONFIRM}
        </Button>
      </Box>
    </FullSizeColumn>
  );
};

export default CampaignsFilters;
